import { render, staticRenderFns } from "./GameLayout.vue?vue&type=template&id=67add958&scoped=true&"
import script from "./GameLayout.vue?vue&type=script&lang=js&"
export * from "./GameLayout.vue?vue&type=script&lang=js&"
import style0 from "./GameLayout.vue?vue&type=style&index=0&id=67add958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67add958",
  null
  
)

export default component.exports